/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ClearProfilePhotoRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/clear_profile_photo_client.pb'
import {ClearProfilePhotoResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/clear_profile_photo_client.pb'


export const clearProfilePhotoApp = (request: ClearProfilePhotoRequest, options?: CashRequestOptions) => post<ClearProfilePhotoRequest, ClearProfilePhotoResponse>("/2.0/cash/clear-profile-photo-app", request, {...options, rejectOnError: true })